import { zodResolver } from "@hookform/resolvers/zod";
import { Checkbox, Typography } from "@material-tailwind/react";
import { ServiceFormProps } from "data/reduxInterfaces";
import { Event } from "data/types";
import { useAppDispatch, useAppSelector } from "hooks/hooks";
import { FC, Fragment, HTMLAttributes, useEffect, useRef } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { fetchEvents } from "redux/features/Admin/Events/eventSlice";
import { getFields } from "redux/features/service/serviceSlice";
import { z } from "zod";

const formSchema = z.object({
  equipments: z.array(z.string()).min(0),
  events: z.array(z.string()).refine((arg) => arg.length > 0, "Merci d'avoir sélectionné au moins un événement."),
});

const ServiceExtraDetails: FC<ServiceFormProps & HTMLAttributes<HTMLDivElement>> = ({
  className,
  isLoading,
  handleForm,
  errorServiceForm,
  FormData,
}) => {
  const dispatch = useAppDispatch();
  const events: Event[] = useAppSelector((state) => state.featureEvent.events);

  const {
    handleSubmit,
    control,

    formState: { errors },
  } = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: { equipments: [], events: [] },
    mode: "onSubmit",
  });

  const onSubmit: SubmitHandler<z.infer<typeof formSchema>> = (data) => {
    FormData(data);
  };

  const prevHandleForm = useRef(handleForm);

  useEffect(() => {
    dispatch(getFields());
    dispatch(fetchEvents());
  }, [dispatch]);

  useEffect(() => {
    if (handleForm.type === "chekServiceFormTwo" && prevHandleForm.current !== handleForm) {
      handleSubmit(onSubmit)();
      prevHandleForm.current = handleForm;
    }
  }, [handleForm, handleSubmit, onSubmit]);

  return (
    <Fragment>
      <div>
        <h2 className="text-2xl font-semibold">Spécification du prestation</h2>
      </div>

      <div className="space-y-8">
        <div>
          <label className="text-lg font-semibold" htmlFor="">
            Type d'événements
          </label>
          <div className="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-3">
            <Controller
              name="events"
              control={control}
              render={({ field }) => {
                const { value, onChange } = field;

                const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                  const selected = event.target.value;
                  let updatedValue;
                  if (value.includes(selected)) {
                    updatedValue = value.filter((v) => v !== selected);
                  } else {
                    updatedValue = [...value, selected];
                  }
                  onChange(updatedValue);
                };

                return (
                  <>
                    {events?.map((event) => (
                      <Checkbox
                        key={event.designation}
                        label={<Typography className="text-dark dark:text-white">{event.designation}</Typography>}
                        value={event.designation}
                        checked={value.includes(event.designation)}
                        onChange={handleCheckboxChange}
                      />
                    ))}
                  </>
                );
              }}
            />
          </div>
          {errors.events?.message && <div className="mt-1 text-xs text-red-500">{errors.events?.message}</div>}
        </div>
      </div>
    </Fragment>
  );
};

export default ServiceExtraDetails;
